



























































import liquidationType from '@/store/types/liquidations';
import { LiquidationParams } from '@/store/interfaces/liquidations';
import DatesFormat from '@/util/classes/datesFormat';
import { navLink } from '@/ts/navegationLinks';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import { moneyFormat } from '@/util/filters';
const formatDate = new DatesFormat();

export default Vue.extend({
  name: 'LiquidationsHome',
  data: () => ({
    backwardLiquidations: 0,
    pendingLiquidations: 0,
    navlink: [
      {
        name: 'Cuentas de usuario',
        active: false,
        to: '/accounts',
      },
      {
        name: 'Transacciones',
        active: true,
      }
    ] as navLink[],
    liquidation: {},
    viewDetails: false,
    propsToSearch: ['business_name', 'tradename'] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'id',
        label: 'Codigo',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'company_name',
        label: '', // assigned in created function
        minWidth: 380,
        sortable: true,
        formatter: (row: LiquidationParams) => {
          return `${row.company.business_name}`;
        },
      },
      {
        prop: 'created_at',
        label: 'Fecha de generacion',
        minWidth: 180,
        formatter: (row: LiquidationParams) => {
          return `${formatDate.formatDateTime(String(row.created_at))}`;
        },
        sortable: true,
      },
      {
        prop: 'liquidation_period',
        label: 'Fecha a liquidar',
        formatter: (row: LiquidationParams) => {
          return `${formatDate.formatYear(row.period_from)} / ${formatDate.formatYear(row.period_to)}`;
        },
        minWidth: 180,
        sortable: true,
      },
      {
        prop: 'subtotal_cents',
        label: 'Volumen total de transacciones',
        minWidth: 280,
        formatter: (row: LiquidationParams) => {
          return moneyFormat((row.subtotal_cents + row.tip_cents) / 100);
        },
        sortable: true,
      },
      {
        prop: 'transactions_count',
        label: 'Cantidad de transacciones',
        minWidth: 220,
        sortable: true,
      },
      {
        prop: 'subtotal_without_taxes_cents',
        label: 'Monto comisionable',
        minWidth: 180,
        formatter: (row: LiquidationParams) => {
          return moneyFormat(row.subtotal_without_taxes_cents / 100);
        },
        sortable: true,
      },
      {
        prop: 'total_cents',
        label: 'Monto a liquidar neto',
        minWidth: 190,
        formatter: (row: LiquidationParams) => {
          return moneyFormat(row.total_cents / 100);
        },
        sortable: true,
      },
      {
        prop: 'stated_taxes_cents',
        label: 'Total IVA',
        minWidth: 100,
        formatter: (row: LiquidationParams) => {
          return moneyFormat(row.stated_taxes_cents / 100);
        },
        sortable: true,
      }
    ] as tTableColumns,
    rowSelected: undefined,
    showevent: false,
  }),
  computed: {
    ...mapGetters({
      getLiquidationList: `liquidationModule/${liquidationType.getters.GET_LIQUIDATIONS}`,
    }),
  },
  created() {
    this.$data.tableColumns[1].label = `Nombre de la ${this.$t('menu.company.singular.informal').toString()}`;
  },
  mounted() {
    this.liquidationList();
  },
  methods: {
    ...mapActions({
      liquidationList: `liquidationModule/${liquidationType.actions.LIQUIDATION_LIST}`,
      singleLiquidation: `liquidationModule/${liquidationType.actions.SINGLE_LIQUIDATION}`,
    }),
    rowselect(row: {id: string}): void{
      this.$data.rowSelected = row;
      if (this.singleLiquidation) {
        this.singleLiquidation(row.id);
      }
    },
    viewDetailsAction(): void{
      this.$router.push({
        name: 'liquidation-detail',
        params: {
          liquidation_id: this.$data.rowSelected.id,
        },
      });
    },
  },
});
